import React from "react";

// The special tiles drawn exactly as the game board draws them
// (frontend/public/game/jangle.html): a Connector Tile is the cross-and-ring
// in the tile's own colour, a Shield (wall) Tile is the steel crate.
export const CONNECTOR_LETTER = "~";
export const SHIELD_LETTER = "#";
export const SHIELD_BG = "#302c2c url(/game/shield-tile-steel.png) center/100% 100% no-repeat";

export function ConnectorIcon({ className = "" }) {
  return (
    <svg className={`w-full h-full block ${className}`} viewBox="0 0 100 100" aria-label="Connector Tile">
      <path
        fill="currentColor" fillOpacity=".65" fillRule="evenodd"
        d="M41.5 14H58.5A2 2 0 0 1 60.5 16V26.21A26 26 0 0 1 73.79 39.5H84A2 2 0 0 1 86 41.5V58.5A2 2 0 0 1 84 60.5H73.79A26 26 0 0 1 60.5 73.79V84A2 2 0 0 1 58.5 86H41.5A2 2 0 0 1 39.5 84V73.79A26 26 0 0 1 26.21 60.5H16A2 2 0 0 1 14 58.5V41.5A2 2 0 0 1 16 39.5H26.21A26 26 0 0 1 39.5 26.21V16A2 2 0 0 1 41.5 14ZM50 40.5A9.5 9.5 0 1 0 50 59.5A9.5 9.5 0 1 0 50 40.5Z"
      />
    </svg>
  );
}

// The letters a move added, as text: special tiles are named rather than
// shown as their "~" / "#" codes, e.g. "UP · Connector Tile".
export function tilesText(letters) {
  const word = letters.filter((l) => l && l !== CONNECTOR_LETTER && l !== SHIELD_LETTER).join("");
  const conn = letters.filter((l) => l === CONNECTOR_LETTER).length;
  const wall = letters.filter((l) => l === SHIELD_LETTER).length;
  return [
    word,
    conn && (conn > 1 ? `${conn} Connector Tiles` : "Connector Tile"),
    wall && (wall > 1 ? `${wall} wall tiles` : "wall tile"),
  ].filter(Boolean).join(" · ");
}

// A gem square (Fortress): the game's purple gem marker. Landing a tile on
// one earns a wall tile.
export function GemIcon({ className = "" }) {
  const id = React.useId().replace(/:/g, "");
  return (
    <svg className={`w-full h-full block ${className}`} viewBox="0 0 100 100" aria-label="Gem square">
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#d9a8ff" />
          <stop offset="1" stopColor="#6a1fb0" />
        </linearGradient>
      </defs>
      <path fill={`url(#${id})`} d="M50 13L81 50L50 87L19 50Z" />
      <path fill="#fff" fillOpacity=".28" d="M50 13L38 50H19Z" />
      <path fill="none" stroke="#fff" strokeOpacity=".5" strokeWidth="2.5" d="M50 13L62 50L50 87L38 50ZM19 50H81" />
    </svg>
  );
}
